// extracted by mini-css-extract-plugin
export default {"heading":"Ju-z","corrected":"Ku-z","redirectVerbiageContainer":"Lu-z","redirectVerbiageText":"Mu-z"};